<template>
    <div>
        <v-simple-table class="px-5 pb-5">
            <thead>
                <tr>
                    <th class="th_mobile" rowspan="2">Thời gian tạo</th>
                    <th class="th_mobile" rowspan="2">SĐT</th>
                    <th rowspan="2">CSKH<br>(Mô tả chi tiết)</th>
                    <th rowspan="2">Ticket gấp</th>
                    <th rowspan="2">Nguồn yêu cầu</th>
                    <th class="th_status" rowspan="2">Kết quả hỗ trợ</th>
                    <th rowspan="2">CSKH<br>(Mô tả hỗ trợ)</th>
                    <th rowspan="2">Người nhận</th>
                    <th colspan="2">Thời gian xử lý</th>
                </tr>
                <tr>
                    <th>Bắt đầu</th>
                    <th>Kết thúc</th>
                </tr>
            </thead>
            <tbody v-for="(item, index) in requestList" :key="index">
                <tr @click="item.expanded = !item.expanded">
                    <td class="text-center">{{ formatDate(item.createdAt) }}</td>
                    <td class="text-center">{{ item.mobile }}</td>
                    <td class="td_request">
                        <b>{{ item.request }}</b>:<br>
                        {{ item.descriptionRequest }}
                    </td>
                    <td class="text-center td_urgent">{{ item.urgentRequest }}</td>
                    <td class="text-center">{{ item.userFullName }}</td>
                    <td><div :style="getStatusStyle(item.status)">{{ getStatus(item.status) }}</div></td>
                    <td class="td_request">{{ item.descriptionSupport }}</td>
                    <td>{{ item.supporterName }}</td>
                    <td class="text-center">{{ formatDate(item.startCallTime) }}</td>
                    <td class="text-center">{{ formatDate(item.endCallTime) }}</td>
                </tr>
                <tr v-if="item.expanded">
                    <td colspan="100">
                        <v-row style="min-height: 50px;">
                            <v-col cols="12" md="6">
                                <b>Mô tả chi tiết</b><br>
                                {{ item.descriptionRequest }}
                            </v-col>
                            <v-col cols="12" md="5">
                                <b>Mô tả hỗ trợ</b><br>
                                {{ item.descriptionSupport }}
                            </v-col>
                            <v-col cols="12" md="1" class="text-center">
                              <input
                                  accept="image/*, video/*"
                                  type="file"
                                  id="input-upload-file"
                                  style="display: none"
                                  @change="changeFile()"
                              />

                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn class="mr-2 file-icon"
                                         @click="clickUpload(item)"
                                         icon small
                                         v-on="on"
                                  >
                                    <v-icon>mdi-attachment</v-icon>
                                  </v-btn>
                                </template>
                                <span>Đính kèm( ảnh/video)</span>
                              </v-tooltip>

                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                      @click="viewFileAttachment(item)"
                                      icon small color="default"  v-on="on">
                                    <v-icon>mdi-image-area</v-icon>
                                  </v-btn>
                                </template>
                                <span>Xem ảnh/video</span>
                              </v-tooltip>
                            </v-col>
                        </v-row>
                    </td>
                </tr>
            </tbody>

            <tbody v-if="requestList.length <= 0">
                <tr>
                    <td colspan="100">
                        <common-no-result />
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <div class="pb-3">
<!--            <v-pagination-->
<!--                v-if="totalItem > limit"-->
<!--                v-model="currentPage"-->
<!--                class="justify-sm-end"-->
<!--                :length="getTotalItem(totalItem)"-->
<!--                prev-icon="mdi-menu-left"-->
<!--                next-icon="mdi-menu-right"-->
<!--            />-->

          <v-col cols="12" md="12" class="pb-0"
                 style="display: flex; justify-content: flex-end; padding: 0 12px">
            <div class="text-right mb-1 mt-2">
              {{ showIndex() }}
              <v-btn
                  small
                  class="pagination-btn-left"
                  @click="function() { currentPage--; }"
                  :disabled="currentPage == 1">
                <v-icon>mdi-menu-left</v-icon>
              </v-btn>
              <v-btn
                  :disabled="requestList.length < limit"
                  small
                  class="pagination-btn-right"
                  @click="function() { currentPage++; }">
                <v-icon>mdi-menu-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </div>
        <modal-view-file-attachment></modal-view-file-attachment>
    </div>
</template>

<script>
import TokenService from '@/helpers/token'
import moment from 'moment'
import RepositoryFactory from '../../../repositories/RepositoryFactory'
import {MAX_SIZE_FILE_UPLOAD} from "@/helpers/constants";
import ModalViewFileAttachment from "@/pages/support/components/ModalViewFileAttachment";
const SupportRepository = RepositoryFactory.get('support')
const ImageRepository = RepositoryFactory.get('image')

export default {
  components: {
    ModalViewFileAttachment
  },
  data() {
        return {
            currentPage: 1,
            requestList: [],
            statusList: [],
            totalItem: 0,
            limit: 10,
            filterForm: {
                mobile: '',
                startDateTime: moment().startOf('isoWeek').format('YYYY-MM-DD'),
                endDateTime: moment().endOf('isoWeek').format('YYYY-MM-DD')
            },
            file: {},
            stringBase64: '',
            requestSelected: {}
        }
    },
    async created() {
        await this.getStatusList()
        this.getRequestList()
        Bus.$on('search-request-support-list', filterForm => {
            this.filterForm = filterForm
            this.getRequestList()
        })
        Bus.$on('fetch-table-while-change-tab', () => {
            this.getRequestList()
        })
    },
    watch: {
        currentPage: {
            handler() {
                this.getRequestList()
            }
        }
    },
    methods: {
        async getRequestList() {
            const loading = this.$loading.show()
            const userId = await TokenService.getId()
            const params = {
                userId,
                ...this.filterForm,
                startDateTime: this.filterForm.startDateTime == '' ? '' : this.filterForm.startDateTime + ' 00:00:00',
                endDateTime: this.filterForm.endDateTime == '' ? '' : this.filterForm.endDateTime + ' 23:59:59',
                limit: this.limit,
                page: this.currentPage,
                order: 'createdAt'
            }
            let res = await SupportRepository.list(params)
            loading.hide()
            if (res.success) {
                this.requestList = _.get(res, 'data', []).map(item => {
                    return {
                        ...item,
                        expanded: false
                    }
                })
                // this.totalItem = _.get(res, 'totalItem', [])
            } else {
                this.requestList = []
                // this.totalItem = 0
            }
        },

        getStatusStyle(status) {
            let style = 'text-align: center; color: white; font-weight: 500; background-color: '

            switch (status) {
                case 'DONE':
                    style += '#67c23a';
                    break;
                case 'CANCELLED':
                    style += '#f56c6c';
                    break;
                case 'NHANYEUCAU':
                    style += '#409eff';
                    break;
                case 'DANGXULY':
                    style += '#e6a23c';
                    break;
                default: 
                    style += '#909399'
            }

            return style
        },

        formatDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY H:mm')
            } else {
                return ''
            }
        },

        async getStatusList() {
            const loading = this.$loading.show()
            let res = await SupportRepository.statusList()
            if (res.success) {
                this.statusList = _.get(res, 'data', [])
            }
            loading.hide()
        },

        getStatus(status) {
            let index = this.statusList.findIndex(item => item.code == status)

            if (index > -1) {
                return this.statusList[index].requests
            } else {
                return ''
            }
        },
      async changeFile() {
        // if (this.details.files.length < 1 || this.details.files.length > 5) {
        //   if (this.details.files.length > 5) {
        //     this.setAlertMessage(true, 'error', 'Không thể tải lớn hơn 5 file đồng thời!')
        //   }
        //   return
        // }


        let element = document.getElementById('input-upload-file')
        if (element) {
          let files = element.files

          if (files.length) {
            this.file = files[0]
          }
        }

        if(this.file) {
          let checkError = false;
          if (this.file.size > MAX_SIZE_FILE_UPLOAD) {
            checkError = true;
            this.file = null;
          }
          if (checkError) {
            this.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: 'Không thể tải file lớn hơn 5 MB !'
            });
            return
          }
          this.getBase64(this.file).then(
              data => {
                this.uploadFile(data);
              }
          );
        } else {

        }
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(
              reader.result
                  .replace("data:", "")
                  .replace(/^.+,/, "")
          );
          reader.onerror = error => reject(error);
        });
      },
      async uploadFile(data) {

        // let checkError = false;
        // if (this.file.size > MAX_SIZE_FILE_UPLOAD) {
        //   checkError = true;
        // }
        // if (checkError) {
        //   this.$swal({
        //     type: 'error',
        //     title: 'Lỗi !',
        //     text: 'Không thể tải file lớn hơn 2 MB !'
        //   });
        //   return
        // }

        const file = {
          name: this.file.name.trim(),
          content: data,
          size: this.file.size,
          type: this.file.type
        }

        this.loading = this.$loading.show()
        const response = await ImageRepository.uploadAttachment(file)
        if (response.code != 200) {
          this.loading.hide()
          this.$swal({
            title: 'Lỗi!',
            text: `Tải file thất bại! ${response.message}`
          })
        } else {
          let urlFile = _.get(response, 'data.urlSave', '');
          const params = {
            mobile: this.requestSelected.mobile,
            request: this.requestSelected.request,
            descriptionRequest: this.requestSelected.descriptionRequest,
            urgentRequest: this.requestSelected.urgentRequest,
            urlFileAttachment: urlFile,
            typeFileAttachment: this.file.type
          }
          let res = await SupportRepository.updateRequest(this.requestSelected.id, params)
          this.loading.hide()
          if (res.success) {
            this.$swal({
              title: "File upload thành công!"
            })
            this.getRequestList();
          } else {
            this.$swal({
              title: 'Lỗi!',
              text: _.get(res, 'message', ''),
            })
          }
        }
      },
      viewFileAttachment(item) {
          if(item.fileUrl && item.fileType) {
            Bus.$emit('view-file-attachment', item)
          } else {
            this.$swal({
              // title: 'Lỗi !',
              text: 'Ticket không có file đính kèm.'
            })
          }
      },
      clickUpload(item) {
        this.requestSelected = item
        let element = document.getElementById('input-upload-file')
        if (element) {
          element.click()
        }
      },
      showIndex() {
        if (this.requestList.length > 0) {
          let maxIndex = this.requestList.length < this.limit ? parseInt(this.currentPage - 1) * parseInt(this.limit) + this.requestList.length : parseInt(this.currentPage) * parseInt(this.limit)
          return this.requestList.length < this.limit ? (maxIndex - parseInt(this.requestList.length) + 1) + ' - ' + maxIndex : (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
        } else {
          return ('0 - 0')
        }
      },
    }
}
</script>

<style scoped>
/deep/table tr th {
    text-align: center !important;
    border: 1px solid #d2d2d2 !important;
    height: 30px;
    font-weight: 500 !important;
}

/deep/table tr td {
    border: 1px solid #d2d2d2 !important;
    height: 35px !important;
    padding: 0px 5px !important;
}

.th_mobile {
    width: 110px;
}

.th_status {
    width: 130px;
}

.td_request {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 250px;
}

.td_urgent {
    max-width: 150px !important;
    min-width: 100px !important;
}
.file-icon {
  transform: rotate(-45deg);
}
</style>